import React from "react";

import { Search } from "../icons_new";

export default function({
  value, 
  onChange,
  placeholder="Search...",
  className="",
}) {
  return (
    <div className={`relative w-full ${className}`}>
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="w-[60%] rounded-md border border-[#b7b7b7] bg-white py-2 pl-10 pr-4 text-sm text-[#333] placeholder-[#888] focus:outline-none focus:ring-2 focus:ring-[#1100ef]"
      />
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#999]" />
    </div>
  );
}